'use client';

import { useAtomRefresh, useAtomValue } from '@effect/atom-react';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';

import { glossarySearchItemsPerPage } from '@vs-shop/engine/config/glossary';

import { GlossaryEmptyState } from './GlossaryEmptyState';
import { GlossaryLoadError } from './GlossaryLoadError';
import { GlossarySkeletonGrid } from './GlossarySkeletonGrid';
import { GlossaryGroupedList } from '../../../server/page/glossary/GlossaryGroupedList';

import { fetchGlossaryTermsAtom } from '../../../../effect/atom/glossary/fetchGlossaryTerms';
import { GlossaryMode } from '../../../../effect/data/glossary/glossaryMode';

type Props = {
  nameFilter: string;
};

export function GlossarySearchView({ nameFilter }: Props) {
  const searchAtom = fetchGlossaryTermsAtom(null, nameFilter, false, 1, glossarySearchItemsPerPage);
  const response = useAtomValue(searchAtom);
  const retry = useAtomRefresh(searchAtom);

  return AsyncResult.match(response, {
    onInitial: () => <GlossarySkeletonGrid />,
    onFailure: () => <GlossaryLoadError onRetry={retry} />,
    onSuccess: ({ value }) => {
      const terms = value['hydra:member'];
      if (terms.length === 0) {
        return <GlossaryEmptyState mode={GlossaryMode.search} searchQuery={nameFilter} />;
      }
      return <GlossaryGroupedList terms={terms} />;
    },
  });
}
